import { render, staticRenderFns } from "./formVersion.vue?vue&type=template&id=340b9556&"
import script from "./formVersion.vue?vue&type=script&lang=js&"
export * from "./formVersion.vue?vue&type=script&lang=js&"
import style0 from "./formVersion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports